module.exports = __webpack_public_path__ + "media/barcelona musica/picasso-15c24ed7.jpg";